<template>
    <div class="form-group mt_0">
         <label class="add_text_label label_text_add_text add_update_text"
            >Text</label
        ><span class="highlight"></span>
        <textarea
            @input="setText"
            type="text"
            rows="2"
            style="min-height: 72.2px"
            id="text_area_box"
            required="required"
            placeholder="Enter Text"
            v-model="inputText"
            class="span2 form-control text_input_pad distress_first_input"
        />
       
    </div>
</template>

<script>
export default {
    name: "TextArea",
    props: ["text"],
    data: () => {
        return {
            inputText: ""
        };
    },
    watch: {
        text: function (newData, oldData) {
            this.inputText = newData;
            console.log(oldData);
        }
    },
    methods: {
        expandHeight() {
            debugger;
        },
        setText(e) {
            console.log(e.inputType);
            if (e.inputType == "insertLineBreak") {
                setTimeout(function () {
                    e.target.scrollTop += 27;
                }, 200);
            }
            this.$emit("set-value", e.target.value);
        }
    }
};
</script>

<style></style>
